import React, { memo, useCallback } from 'react';

import { Button, Modal, Spin } from 'antd';

interface IProps {
  opened: boolean;
  submitDisabled?: boolean;
  submitLoading?: boolean;
  children: React.ReactNode;
  title?: string;
  message?: string | React.ReactNode;
  showOk?: boolean;
  showCancelButton?: boolean;
  customOkButton?: React.ReactNode;
  buttonOk?: string;
  buttonCancel?: string;
  disableBackdropClick?: boolean;
  onClose: () => void;
  onSubmit?: () => void;
}

const MyModal = memo(({ showOk = true, showCancelButton = true, ...props }: IProps) => {
  const handleOk = useCallback(() => props.onSubmit(), [props]);
  const handleCancel = useCallback(() => props.onClose(), [props]);

  if (!props.opened) {
    return null;
  }

  return (
    <Modal
      open={props.opened}
      onCancel={handleCancel}
      maskClosable={!props.disableBackdropClick}
      className='z-[1600]'
      width={600}
      title={props.title}
      footer={
        <div className='flex justify-end gap-2 p-2'>
          {showCancelButton && <Button onClick={handleCancel}>{props.buttonCancel ?? 'Cancelar'}</Button>}
          {showOk && (
            <Button
              onClick={handleOk}
              disabled={props.submitDisabled}
              type='primary'
              htmlType='submit'
              icon={props.submitLoading ? <Spin size='small' /> : undefined}
            >
              {props.buttonOk ?? 'Prosseguir'}
            </Button>
          )}
          {props?.customOkButton && props.customOkButton}
        </div>
      }
    >
      {props.message && <p className='mb-4 min-w-[150px] text-gray-500'>{props.message}</p>}
      {props.children}
    </Modal>
  );
});

export default MyModal;
